import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { ModelService } from '../../../services/model.service';

@Component({
	host: { 
		'( document: click )': 'onClickOutside( $event )'
	},
  selector: 'search-sku',
  templateUrl: './search-sku.component.html',
  styleUrls: ['./search-sku.component.scss']
})
export class SearchSKUComponent implements OnChanges {

  SKUList: any[] = [];
	descriptionList: any[] = [];

	timeout: any;

	dropdownVisible: boolean = false;

	inRequest: boolean = false;

  @Input( ) 
  SKUSearch: any;

	@Input( ) 
	descriptionSearch: any;

  @Output( )
  onAddSKU = new EventEmitter<any>( );

	@Output( )
	onAddDescription = new EventEmitter<any>( );

	@ViewChild( "mainContainer" )
	mainContainer: ElementRef;

  constructor( private model: ModelService ) { }

  ngOnChanges ( changes: SimpleChanges ) {
  	// console.log( changes );
  }

	onClickOutside ( event ) {

		let clickElement = event.target,
				_closest = clickElement.closest( '.sku__wrapper' );


		if ( !this.dropdownVisible ) return;

		if ( ( !_closest || this.mainContainer.nativeElement != _closest ) && 
			this.mainContainer.nativeElement != clickElement && 
			clickElement.getAttribute( 'for' ) != 'inputSearchSKU' ) {
			this.dropdownVisible = false;
		}

	}

  onKeydown( event ) { 
    if ( this.dropdownVisible && ( event.key == 'Escape' || event.key == 'Tab' ) ) this.dropdownVisible = false;
  }

  getSKUList ( ) {
    this.model.getSKUList( this.SKUSearch )
      .then( ( response: any ) => {
        this.inRequest = false;
        this.SKUList = response.SKUList;
        if ( this.SKUList.length ) {
          this.dropdownVisible = true;
        }
      });
  }

  onInputSKUHandler ( ) {
    clearTimeout( this.timeout );
    this.inRequest = true;
    this.dropdownVisible = false;
    this.SKUList = [];
    this.timeout = setTimeout( ( ) => { 
      if ( this.SKUSearch.trim( ) ) {
        this.getSKUList( );
      }
    }, 750 );

  }

  onSelectSKU ( value ) {
    this.dropdownVisible = false;
    this.SKUSearch = value;
    this.searchSKU( );
  }

  searchSKU ( ) {
    this.SKUList = [];
    this.onAddSKU.emit({ value: this.SKUSearch });
  }

  getDescriptionList ( ) {
  	this.model.getDescriptionList( this.descriptionSearch )
  		.then( ( response: any ) => {
		  	this.inRequest = false;
  			this.descriptionList = response.DescriptionList;
  			if ( this.descriptionList.length ) {
			  	this.dropdownVisible = true;
  			}
  		});
  }

  onInputDescriptionHandler ( ) {
  	clearTimeout( this.timeout );
  	this.inRequest = true;
  	this.dropdownVisible = false;
		this.descriptionList = [];
  	this.timeout = setTimeout( ( ) => { 
	  	if ( this.descriptionSearch.trim( ) ) {
	  		this.getDescriptionList( );
	  	}
  	}, 750 );

  }

	onSelectDescription ( value ) {
		this.dropdownVisible = false;
		this.descriptionSearch = value.description;
    this.searchDescription( );
	}

  searchDescription ( ) {
    this.descriptionList = [];
  	this.onAddDescription.emit({ value: this.descriptionSearch });
  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/defaults/search-sku/search-sku.component.ts